angular.module('unica_relator.relator_controllers')

.controller('RelatorCreateController', function(
	$rootScope, $scope, $state,
	RelatorCreateService
) {

	$scope.pageTitle = 'Aggiungi Relatore';

	$scope.relatorData = {};

	$scope.saveRelator = function() {
		$scope.showLoader();

		if ( typeof $scope.relatorData.avatar !== "undefined" ) {
			$scope.relatorData.avatar = $scope.relatorData.avatar.dataURL;
		} else {
			$scope.relatorData.avatar = '';
		}

		var relatorData = angular.copy($scope.relatorData);

		RelatorCreateService
			.create(relatorData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Relatore aggiunto con successo!', '');
					$rootScope.relatorData = {};
					$state.go('app.relator.list');
				} else {
					$rootScope.manageError(data);
				}
			});

	};

})

;
